import { useBizMutation, useBizQuery } from '../Hooks/useBizQuery';
import { ObjectType } from '../Types/base';
import { CheckInDefinition, ResolvedCheckIn, SaveCheckInResponsesRequest } from '../Types/admin/checkIn';
import { get, httpDelete, post, postOnUnload } from './common';

const adminEndpoint = 'api/checkinadmin';
const checkInEndpoint = 'api/checkin';

const QUERYKEY_CHECKIN_DEFINITIONS = 'CHECKIN_DEFINITIONS';
const QUERYKEY_CHECKIN_RESOLVED = 'CHECKIN_RESOLVED';

export async function getCheckInDefinitions(objectType?: ObjectType) {
	const objectTypeQuery = objectType !== undefined ? `?objectType=${objectType}` : '';
	return await get<CheckInDefinition[]>(`${adminEndpoint}/GetDefinitions${objectTypeQuery}`);
}

export async function saveCheckInDefinition(definition: CheckInDefinition) {
	return await post<CheckInDefinition>(`${adminEndpoint}/SaveDefinition`, definition);
}

export async function deleteCheckInDefinition(definitionId: number) {
	return await httpDelete<boolean>(`${adminEndpoint}/DeleteDefinition?definitionId=${definitionId}`);
}

export async function getResolvedCheckIns(objectType: ObjectType, objectId: number) {
	return await get<ResolvedCheckIn[]>(`${checkInEndpoint}/GetResolvedCheckIns?objectType=${objectType}&objectId=${objectId}`);
}

export async function saveCheckInResponses(request: SaveCheckInResponsesRequest) {
	return await post<boolean>(`${checkInEndpoint}/SaveResponses`, request);
}

export async function saveCheckInResponsesOnUnload(request: SaveCheckInResponsesRequest) {
	return await postOnUnload(`${checkInEndpoint}/SaveResponses`, request);
}

export const useGetCheckInDefinitions = (objectType?: ObjectType) => {
	return useBizQuery([QUERYKEY_CHECKIN_DEFINITIONS, objectType ?? 'all'], () => getCheckInDefinitions(objectType));
};

export const useSaveCheckInDefinition = () => {
	return useBizMutation(saveCheckInDefinition, {
		getQueryKeyForInvalidation: () => [[QUERYKEY_CHECKIN_DEFINITIONS]],
	});
};

export const useDeleteCheckInDefinition = () => {
	return useBizMutation(deleteCheckInDefinition, {
		getQueryKeyForInvalidation: () => [[QUERYKEY_CHECKIN_DEFINITIONS]],
	});
};

export const useGetResolvedCheckIns = (objectType: ObjectType, objectId: number) => {
	return useBizQuery(
		[QUERYKEY_CHECKIN_RESOLVED, objectType, objectId],
		() => getResolvedCheckIns(objectType, objectId),
		objectId > 0
	);
};

export const useSaveCheckInResponses = () => {
	return useBizMutation(saveCheckInResponses, {
		getQueryKeyForInvalidation: (variables) => [[QUERYKEY_CHECKIN_RESOLVED, variables.objectType, variables.objectId]],
	});
};
